import React, { useState, useEffect } from "react";
import { DashboardShell } from "./DashboardShell";
import { DashboardHero, DashboardTab } from "./DashboardHero";
import { DashboardDataProvider } from "@/context/DashboardDataContext";
import { ExploreCourses } from "./ExploreCourses";
import { ExploreSection } from "./ExploreSection";
import { MyRoomsSection } from "./MyRoomsSection";
import { RecentsSection } from "./RecentsSection";
import { supabase } from "@/integrations/supabase/client";

export const DashboardLayout: React.FC = () => {
  const [activeTab, setActiveTab] = useState<DashboardTab>("study");
  const [hasContent, setHasContent] = useState<boolean | null>(null);

  useEffect(() => {
    const checkContent = async () => {
      const { count } = await supabase
        .from("content")
        .select("*", { count: "exact", head: true });
      
      setHasContent((count ?? 0) > 0);
    };

    checkContent();

    // Listen for content changes
    const handleContentUploaded = () => {
      checkContent();
    };
    window.addEventListener("content-uploaded", handleContentUploaded);

    // Realtime subscription for content changes
    const channel = supabase
      .channel("dashboard-content-check")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "content" },
        () => checkContent()
      )
      .subscribe();

    return () => {
      window.removeEventListener("content-uploaded", handleContentUploaded);
      supabase.removeChannel(channel);
    };
  }, []);

  return (
    <DashboardDataProvider>
      <DashboardShell>
        <main className="flex-1 px-4 sm:px-6 lg:px-8">
          <div className="mx-auto w-full max-w-7xl">
            <DashboardHero activeTab={activeTab} onTabChange={setActiveTab} />
            {activeTab === "mastery" && <ExploreCourses />}
            <MyRoomsSection />
            {activeTab === "study" && !hasContent && <ExploreSection />}
            {hasContent && <RecentsSection />}
          </div>
        </main>
      </DashboardShell>
    </DashboardDataProvider>
  );
};
